// alterado - revisado

import React from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import {
    SvgIconReceitaMensal,
} from '../../../business-components/SvgIcon/SvgIconGarantiasAtuais/SvgIconGarantiasAtuais'

import {
    SvgIconDiaDia,
    SvgIconEducacao,
    SvgIconFinanciamento,
    SvgIconProjetoVidaSonho,
} from '../../../business-components/SvgIcon/SvgIconDespesasTotais/SvgIconDespesasTotais'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    StepperPadrao
} from '../../../business-components/Stepper/Stepper'

import {
    calculaIdadesDataSimulacao,
} from '../cliente-form/ClienteService'

import {
    incluiReceitaMensalInssPensaoAluguelPatrimonioImobilizadoAluguel,
    calculaTotaisReceitaMensal,
} from '../garantias-form/GarantiasServiceReceitaMensal'

import {
    calculaTotaisDiaDia,
} from '../despesas-form/DespesasServiceDiaDia'

import {
    processaRegistrosDefaultIniciaisEducacao,
    calculaTotaisEducacao,
} from '../despesas-form/DespesasServiceEducacao'

import {
    calculaTotaisFinanciamento,
} from '../despesas-form/DespesasServiceFinanciamento'

import {
    calculaTotaisProjetoVidaSonho,
} from '../projetoVidaSonho-form/ProjetoVidaSonhoServiceProjetoVidaSonho'

import GarantiasFormReceitaMensal from '../garantias-form/GarantiasFormReceitaMensal'

import DespesasFormDiaDia from '../despesas-form/DespesasFormDiaDia'

import DespesasFormEducacao from '../despesas-form/DespesasFormEducacao'

import DespesasFormFinanciamento from '../despesas-form/DespesasFormFinanciamento'

import ProjetoVidaSonhoFormProjetoVidaSonho from '../projetoVidaSonho-form/ProjetoVidaSonhoFormProjetoVidaSonho'



const FluxoCaixaForm = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca,
    jsonConfiguracao }) => {

    useSingleton(async () => {
        
        calculaIdadesDataSimulacao(values, false)

        calculaTotaisDiaDia(values, jsonConfiguracao)

        processaRegistrosDefaultIniciaisEducacao(values, jsonConfiguracao)
        calculaTotaisEducacao(values)

        calculaTotaisFinanciamento(values)

        calculaTotaisProjetoVidaSonho(values)
    })

    const stepsSvgIcon = [
        SvgIconReceitaMensal,
        SvgIconDiaDia,
        SvgIconEducacao,
        SvgIconFinanciamento,
        SvgIconProjetoVidaSonho,
    ]

    const steps = [
        LABEL.receitaMensal1aParte,
        LABEL.diaDia,
        LABEL.educacao,
        LABEL.financiamento,
        LABEL.projetoVidaSonho1aParte,
    ]

    const stepsTitle2 = [
        LABEL.receitaMensal2aParte,
        '',
        '',
        '',
        LABEL.projetoVidaSonho2aParte,
    ]

    const stepsContent = [
        <GarantiasFormReceitaMensal
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
        />,
        <DespesasFormDiaDia
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            linhaTipoLicenca={linhaTipoLicenca}
            jsonConfiguracao={jsonConfiguracao}
        />,
        <DespesasFormEducacao
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            jsonConfiguracao={jsonConfiguracao}
        />,
        <DespesasFormFinanciamento
            variaveisGlobais={variaveisGlobais}
            values={values}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            setFieldValue={setFieldValue}
            linhaTipoLicenca={linhaTipoLicenca}
        />,
        <ProjetoVidaSonhoFormProjetoVidaSonho
            values={values}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            linhaTipoLicenca={linhaTipoLicenca}
        />,
    ]
    
    const valuesStepsTitle2 = [
        '',
        LABEL.valorNaAposentadoria,
        '',
        '',
        '',
    ]

    incluiReceitaMensalInssPensaoAluguelPatrimonioImobilizadoAluguel(values)

    if (values.stepFluxoCaixa.activeStep === 0) {
        calculaTotaisReceitaMensal(values)
    } else {
        if (values.stepFluxoCaixa.activeStep === 1) {
            calculaTotaisDiaDia(values, jsonConfiguracao)
        } else {
            if (values.stepFluxoCaixa.activeStep === 2) {
                calculaTotaisEducacao(values)
            } else {
                if (values.stepFluxoCaixa.activeStep === 3) {
                    calculaTotaisFinanciamento(values)
                } else {
                    if (values.stepFluxoCaixa.activeStep === 4) {
                        calculaTotaisProjetoVidaSonho(values)
                    }
                }
            }
        }
    }

    return (
        <ValidatorFormPadrao 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <StepperPadrao
                stepsType={"cardValor"}
                stepsSvgIcon={stepsSvgIcon}
                steps={steps}
                stepsTitle2={stepsTitle2}
                stepsContent={stepsContent}
                valuesStep={values.stepFluxoCaixa}
                valuesStepsValor={values.stepsValorFluxoCaixa}
                valuesStepsTitle2={valuesStepsTitle2}
                valuesStepsValor2={values.stepsValor2FluxoCaixa}
                valuesStepsValorSubTotal1={values.stepsValorSubTotal1FluxoCaixa}
                valuesStepsValorSubTotal2={values.stepsValorSubTotal2FluxoCaixa}
                naoPermiteConcluir={true}
            />
        </ValidatorFormPadrao>
    )
}

export default FluxoCaixaForm